import React, { useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Mode } from '../profile.type';
import PageBreadcrumb, {
  PageBreadcrumbItem
} from 'components/common/PageBreadcrumb';
import Button from 'components/base/Button';
import { routeMapping } from '../config';
import { FormValues, Props } from './profilePasswordReset.type';
import PasswordResetForm from './form/PasswordResetForm';
import { FormikProps } from 'formik';

const defaultBreadcrumbItems: Record<Mode, PageBreadcrumbItem[]> = {
  institution: [
    {
      label: 'Profile',
      url: '/hub/profile/view'
    },
    {
      label: 'Reset Account Password',
      url: '/hub/profile/reset-password',
      active: true
    }
  ],
  candidate: [
    {
      label: 'Profile',
      url: '/home/profile/view'
    },
    {
      label: 'Reset Account Password',
      url: '/home/profile/reset-password',
      active: true
    }
  ],
  recruiter: [
    {
      label: 'Profile',
      url: '/panel/profile/view'
    },
    {
      label: 'Reset Account Password',
      url: '/panel/profile/reset-password',
      active: true
    }
  ]
};

function ProfilePasswordReset({ mode }: Props) {
  const formRef = useRef<FormikProps<FormValues> | null>(null);
  const handleSubmit = () => {
    formRef.current?.submitForm();
  };
  return (
    <>
      <PageBreadcrumb items={defaultBreadcrumbItems[mode]} />
      <Row className="align-items-center justify-content-between g-3 mb-4">
        <Col xs="auto">
          <h2 className="mb-0">Reset Password</h2>
        </Col>
        <Col xs="auto" className="d-flex flex-wrap gap-2 gap-sm-3">
          <Button
            variant="phoenix-secondary"
            as={Link}
            to={routeMapping[mode].view}
          >
            Back
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Reset Password
          </Button>
        </Col>
      </Row>
      <PasswordResetForm innerRef={formRef} />
    </>
  );
}

export default ProfilePasswordReset;
